<template>
  <div class="section portrait">
    <div class="col1 court" :class="'r'+court">
      <div class="autoMargin">{{ court }}</div>
    </div>

    <template v-if="currentGame.length>0">
      <template v-for="item in currentGame">
        <div class="col2 currentGame booked">
          <div class="autoMargin">
            <div class="threeTeams" v-if="item.line_1 && item.line_2 && item.line_3">
              <label :class="{ border: !item.vs_1 }">{{ item.line_1 }}</label><br />
              <template v-if=" item.vs_1"><small>vs</small><br />
              </template>
              <label :class="{ border: !item.vs_2 }">{{ item.line_2 }}</label><br />
              <template v-if="item.vs_2"><small>vs</small><br /></template>
              <label :class="{ border: !item.vs_2 }">{{ item.line_3 }}</label>
            </div>
            <div class="twoTeams" v-if="item.line_1 && item.line_2 && !item.line_3">
              <label :class="{ border: !item.vs_1 }">{{ item.line_1 }}</label><br />
              <template v-if="item.vs_1"><small>vs</small><br /></template>
              <label>{{ item.line_2 }}</label>
            </div>
            <div class="oneDescription" v-if="item.line_1 && !item.line_2 && !item.line_3">
              {{ item.line_1 }}
            </div>
          </div>
          <div class="cancelled" v-if="item.status == 'cancelled'">
            <div class="autoMargin">
              <span class="icon">
                <i class="fa fa-ban"></i>
              </span><label>CANCELLED</label></div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="col2 currentGame available">
        <div class="autoMargin noGame">Court Available</div>
      </div>
    </template>

    <template v-if="nextGame.length>0">
      <template v-for="item in nextGame">
        <div class="col34 nextGame">
          <div class="autoMargin">
            <label class="time">{{ dateFormat(item.date + ' ' + item.time) }}</label>

            <div class="threeTeams" v-if="item.line_1 && item.line_2 && item.line_3">
              <label :class="{ border: !item.vs_1 }">{{ item.line_1 }}</label><br />
              <template v-if="item.vs_1"><small>vs</small><br /></template>
              <label :class="{ border: !item.vs_2 && !item.vs_1 }">{{ item.line_2 }}</label><br />
              <br v-if="item.vs_1 && !item.vs_2" />
              <template v-if="item.vs_2"><small>vs</small><br /></template>
              <label :class="{ border: !item.vs_2 }">{{ item.line_3 }}</label>
            </div>
            <div class="twoTeams" v-if="item.line_1 && item.line_2 && !item.line_3">
              <label :class="{ border: !item.vs_1 }">{{ item.line_1 }}</label><br />
              <template v-if="item.vs_1"><small>vs</small><br /></template>
              <label>{{ item.line_2 }}</label>
            </div>
            <div class="oneDescription" v-if="item.line_1 && !item.line_2 && !item.line_3">
              {{ item.line_1 }}
            </div>
          </div>
          <div class="cancelled" v-if="item.status == 'cancelled'">
            <div class="autoMargin">
              <span class="icon">
                <i class="fa fa-ban"></i>
              </span><label>CANCELLED</label></div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="col34">
        <div class="autoMargin noGame">Court Available</div>
      </div>
    </template>

  </div>
</template>
<script>
  import axios from "axios";
  import moment from 'moment'; 

  const apiURL = process.env.MIX_LIGHTS_API_URL + "/_/items/timetable_games";
  const apiUrlGraphQL = process.env.MIX_LIGHTS_API_URL + "/graphql";

  export default {
    async mounted() {
      this.getCurrentGame();
      this.getNextGame();
    },
    props: {
      court: 0
    },
    data() {
      return {
        currentGame: [],
        nextGame: [],
        limit: 1,
        today: this.getToday(),
        // time_now: "09:05:00",
        time_now: this.getTime()

      };
    },
    methods: {
      dateFormat(date) {
        date = moment(date)
        return date.format('h:mmA')
      },       
      getToday() {
        var date = new Date();
        date = moment(date)
        return date.format('YYYY-MM-DD')
      },
      getTime() {
        var date = new Date();
        date = moment(date)
        return date.format('HH:mm:ss')
      },
      getCurrentGame: function() {
        axios.get(apiURL+
        '?filter[court][eq]='+this.court+
        '&filter[status][in]=scheduled,cancelled'+
        '&filter[date][eq]='+this.today+
        '&filter[time][lt]='+this.time_now+
        '&filter[time_end][gt]='+this.time_now
        ,{
          params: {
            limit: this.limit,
            sort: "date",
            fields: "date,time,time_end,court,status,line_1,line_2,line_3,vs_1,vs_2"
          }
        })
        .then(response => {
            this.currentGame = response.data.data;
        });
      },
      getNextGame: function() {
        axios.get(apiURL+
        '?filter[court][eq]='+this.court+
        '&filter[status][in]=scheduled,cancelled'+
        '&filter[date][eq]='+this.today+
        '&filter[time][gt]='+this.time_now+
        '&filter[time_end][gt]='+this.time_now
        ,{
          params: {
            limit: this.limit,
            sort: "date",
            fields: "date,time,time_end,court,status,line_1,line_2,line_3,vs_1,vs_2"
          }
        })
        .then(response => {
            this.nextGame = response.data.data;
        });
      }
    }
  };

</script>

<style lang="scss" scoped>
  .section {
    padding: 0;
    margin: 5px 0;
    display: flex;
    height: 342px;
  }


  .landscape {
    .col1 {
      width: 10%;
    }

    .col2 {
      width: 30%;
    }

    .col3 {
      width: 10%;
    }

    .col4 {
      width: 49%;
    }

    .col34 {
      width: 59%;
    }

    .court {
      padding: .72em 0;
    }

  }


  .portrait {
    .col1 {
      width: 9%;
    }

    .col2 {
      width: 45%;
    }

    .col3 {
      width: 10%;
    }

    .col4 {
      width: 49%;
    }

    .col34 {
      width: 45%;
    }

  }

  .col1,
  .col2,
  .col3,
  .col4,
  .col34 {
    position: relative;
    background: rgba(10, 10, 10, .3);
    vertical-align: middle;
    /* display: grid; */
    display: flex;
    align-content: center;
    text-align: center;
    margin: 0 2px;
    color: #fff;
    padding: 0 .4rem;
  }



  .autoMargin {
    margin: auto;
  }

  .cancelled {
    position: absolute;
    right: 0;
    background: red;
    color: #fff;
    /* display: block; */
    display: flex;
    vertical-align: middle;
    align-content: center;
    text-align: center;
    padding: .5em;

    .icon {}
  }

  .court {
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
    text-align: center;

    &.r1 {
      background: #71cc36;
    }

    &.r2 {
      background: #b118d6;
    }

    &.r3 {
      background: #dd4a22;
    }

    &.r4 {
      background: #c10037;
    }

    &.r5 {
      background: #1e92d8;
    }
  }

  .border {
    border: 1px solid #333;
    padding: 8px;
    display: block;
  }


  .currentGame {
    &.booked {
      background: #dadada;
      color: #333;
    }

    &.available {
      background: rgba(218, 218, 218, .05);
      color: #eee;
    }


    .threeTeams {
      label {
        font-size: 1.6rem;
        font-weight: bold;
        line-height: 2.3rem;
      }
    }

    .twoTeams {
      label {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 2.3rem;
      }
    }

    .oneDescription {
      font-size: 1.8rem;
    }

  }

  .nextGame {

    .threeTeams {
      label {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 2.3rem;
      }
    }

    .twoTeams {
      label {
        font-size: 1.6rem;
        font-weight: bold;
        line-height: 2.3rem;
      }
    }

    .oneDescription {
      font-size: 1.6rem;
    }

  }

  .time {
    font-size: 1.8rem;
    font-weight: bold;
    display: block;
    width: 140px;
    margin: auto;
    margin-bottom: 1.2rem;
    background: #fff;
    color: #333;
  }

  .noGame {
    font-size: 1.4rem;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/thelights/Court.vue